import { render, staticRenderFns } from "./BeritaEdit.vue?vue&type=template&id=14e513ad"
import script from "./BeritaEdit.vue?vue&type=script&lang=js"
export * from "./BeritaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports